export default __webpack_public_path__ + "static/media/menuXicon.e8ba81f7.svg";